import { useResolvedCompanyCtx } from '@contexts/ResolvedCompanyContext/ResolvedCompanyProvider'
import { HeroScreen } from '@segments/ScreenLayout'
import * as React from 'react'

import { isDefined } from '~logic/helpers/isDefined'
import { InfoCard } from '~shared/components/InfoCard/InfoCard'
import { StickyGridColumn } from '~shared/components/Sticky/StickyGridColumn'
import { StickyTopContent } from '~shared/components/Sticky/StickyTopContent'
import { ProductCategoryNavigation, useProductListDataCtx } from '~shared/segments/ProductList'
import { Box, Grid } from '~ui/components/layout/Box'

import { useMenuScreenLayout } from '../hooks/useMenuScreenLayout'
import { PromoHeaderText } from './PromoHeaderText'

type TProps = RequiredChildren & {
  shouldRenderCategoryNav: boolean
  cart: React.ReactNode
}

/**
 * Container for the tablet menu screen.
 * Contains the company image and the promo header text.
 */
export const TabletMenuScreenContainer: React.FC<TProps> = ({
  cart,
  shouldRenderCategoryNav,
  children,
}) => {
  const { topCardsMarginBottom, navigationAndCartStickyTopPx } = useMenuScreenLayout()

  const categories = useProductListDataCtx()

  const { resolvedBranch } = useResolvedCompanyCtx()
  const hasPromoHeader = isDefined(resolvedBranch.promoHeaderText)

  return (
    <HeroScreen
      withCompanyDescription
      navigateTo={`home`}
      // TODO - add logo box dimensions
    >
      <InfoCard opacity={hasPromoHeader ? 1 : 0} isMobileOrTablet>
        <PromoHeaderText />
      </InfoCard>

      {/* This empty stickyTopContent is here for scrollToTopButton.
          The button recognizes when to show up based on the sticky top content state. */}
      <StickyTopContent>
        <Box />
      </StickyTopContent>

      <Grid
        margin={{ top: `extraLarge`, bottom: `none`, left: `none`, right: `none` }}
        columnGap={`largePlus`}
        gridTemplateColumns={shouldRenderCategoryNav ? `auto 1fr` : `auto`}
      >
        {shouldRenderCategoryNav && (
          <StickyGridColumn
            width={`15vw`}
            minWidth={`8rem`}
            maxWidth={`14rem`}
            top={`${navigationAndCartStickyTopPx}px`}
            maxHeight={`calc(100vh - ${navigationAndCartStickyTopPx}px)`}
            padding={{ bottom: topCardsMarginBottom, top: `none`, left: `none`, right: `none` }}
          >
            <ProductCategoryNavigation productCategories={categories} />
          </StickyGridColumn>
        )}

        {children}
      </Grid>

      {cart}
    </HeroScreen>
  )
}
